'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('community-show', {
      url: '/community/:id',
      template: '<community-show></community-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/community-show/community-show.routes.js